import axios from '@/lib/v2/axios';
import type { Announcement } from '@/types/announcement';

export async function getAnnouncements(communityId?: string): Promise<Announcement[]> {
  const params = new URLSearchParams();
  if (communityId) {
    params.append('communityId', communityId);
  }
  params.append('include', 'community');
  
  const response = await axios.get(`/api/v1/announcements?${params.toString()}`);
  return response.data?.data ?? [];
}

export async function getAnnouncement(announcementId: string): Promise<Announcement> {
  const response = await axios.get(`/api/v1/announcements/${announcementId}`);
  return response.data?.data as Announcement;
}

export async function deleteAnnouncement(announcementId: string): Promise<void> {
  await axios.delete(`/api/v1/announcements/${announcementId}`);
}